import React from 'react';
import { User, LogOut, ShieldCheck, Wallet, Menu, X, Tag, Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const Navbar = ({ user, onLogout, onToggleMobileSidebar, isMobileSidebarOpen }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-[#09090B]/95 backdrop-blur-md border-b border-[#27272A] h-16 px-4 sm:px-6 flex items-center justify-between">
      {/* Brand & Mobile Hamburger Toggle */}
      <div className="flex items-center space-x-3">
        <button
          onClick={onToggleMobileSidebar}
          className="p-2 rounded-xl text-[#9CA3AF] hover:text-[#FFFFFF] hover:bg-[#121215] lg:hidden focus:outline-none"
          title="Toggle Navigation Menu"
        >
          {isMobileSidebarOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>

        <img 
          src="/logo.png" 
          alt="DUBAI GOLD X Logo" 
          className="w-9 h-9 object-contain rounded-full shadow-sm shrink-0" 
        />
        <div className="hidden sm:block">
          <h1 className="text-sm font-extrabold text-[#FFFFFF] tracking-wider uppercase leading-none">DUBAI GOLD X</h1>
          <p className="text-[10px] text-[#9CA3AF] mt-0.5">MT5 Copy Trading & Profit Sharing</p>
        </div>
      </div>

      {/* User Information, Client ID Tag, Theme Toggle & Status Pill */}
      <div className="flex items-center space-x-2 sm:space-x-3">
        {/* Theme Toggle Button */}
        <button
          onClick={toggleTheme}
          className="p-2 rounded-xl bg-[#121215] border border-[#27272A] text-[#F59E0B] hover:text-[#F97316] transition-all hover:scale-105 active:scale-95 focus:outline-none shadow-sm"
          title={theme === 'dark' ? 'Switch to Light Theme' : 'Switch to Dark Theme'}
        >
          {theme === 'dark' ? (
            <Sun className="w-4 h-4 text-[#F59E0B] transition-transform rotate-0 hover:rotate-45" />
          ) : (
            <Moon className="w-4 h-4 text-[#F97316] transition-transform rotate-0 hover:-rotate-12" />
          )}
        </button>

        {user ? (
          <>
            {/* Unique Platform Client ID Tag */}
            <div className="flex items-center space-x-1.5 bg-[#121215] px-2.5 py-1.5 rounded-xl border border-[#F59E0B]/30" title="Your Unique Platform Client ID">
              <Tag className="w-3.5 h-3.5 text-[#F59E0B] shrink-0" />
              <span className="text-[11px] font-mono font-extrabold text-[#F59E0B] tracking-wider">{user.userIdTag || ''}</span>
            </div>

            <div className="flex items-center space-x-1.5 sm:space-x-2 bg-[#121215] px-2.5 sm:px-3 py-1.5 rounded-xl border border-[#27272A]">
              <Wallet className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#F59E0B] shrink-0" />
              <span className="hidden md:inline text-xs text-[#9CA3AF]">Wallet:</span>
              <span className="text-xs font-bold text-[#10B981]">${Number(user.walletBalance || 0).toFixed(2)}</span>
            </div>

            <div className="flex items-center space-x-2 bg-[#121215] px-2.5 sm:px-3 py-1.5 rounded-xl border border-[#27272A]">
              {user.role === 'admin' ? (
                <ShieldCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#F97316] shrink-0" />
              ) : (
                <User className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#9CA3AF] shrink-0" />
              )}
              <span className="text-xs font-semibold text-[#FFFFFF] max-w-[90px] sm:max-w-[140px] truncate">{user.name || user.email}</span>
              {user.role === 'admin' && (
                <span className="hidden sm:inline-block text-[9px] uppercase px-1.5 py-0.5 rounded-md bg-[#F97316]/20 text-[#F97316] font-extrabold">
                  Admin
                </span>
              )}
            </div>

            <button
              onClick={onLogout}
              className="p-2 rounded-xl text-[#9CA3AF] hover:text-[#EF4444] hover:bg-[#121215] transition-colors"
              title="Logout"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </>
        ) : (
          <div className="text-xs font-semibold text-[#9CA3AF]">Guest Portal</div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
